<template>
  <div class="cp-no-chance">
    <div class="button" @click="handleAddress"></div>
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Close from '~/components/Close/close.vue';
import Alert from "~/components/Alert";
import { mapState } from "vuex";

export default {
  name: 'noChance',
  components: {Close},
  data() {
    return {
      isHome: false,
      isDownload: false,
      isShare: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  },
  mounted() {
  },
  methods: {
    handleAddress() {
      store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {toSlide: true}));
      store.commit(types.HIDE_MODAL);
    },
    handleClose() {
      store.commit(types.HIDE_MODAL);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-no-chance
    position absolute
    width 6.66rem
    height 5.16rem
    background-image url('./images/noChance.png')
    background-size: 6.66rem 4.46rem;
    background-repeat: no-repeat;
    background-position 0 0
    .button
      width 2.32rem
      height 0.86rem
      background-size: 100% 100%;
      background-image url('./images/view.png')
      background-repeat: no-repeat;
      position absolute
      top 2.67rem
      left 50%
      margin-left -1.16rem
      animation fadeIn 0.3s ease

@keyframes fadeIn {
  from {
    opacity 0
  }
  to {
    opacity: 1
  }
}
</style>
